import Axios from "axios";
import Store from 'redux/store';
import {
  FETCH_AVAILABILITY_GENERIC_FAIL,
  FETCH_AVAILABILITY_GENERIC_SUCCESS,
} from 'redux/Reducers/Availability/AvailabilityGenericReducer';
import { genericSupplierEndpoint } from '../clients';
import { fetchFromCacheOrAPI } from '../fetchFromCacheOrAPI';
import PipeProviderStateSingleton from '../../Providers/PipeProvider/PipeProviderState.singleton';
import generateUUID from '../../../Utils/generateUUID';

export async function fetchAvailabilityGeneric(User, sku, originalId, vendorId,) {
  return await genericSupplierEndpoint(User).get(`/product/${sku}/Availability?OriginalId=${originalId}&VendorId=${vendorId}`);
}

const fetchAvailabilityGenericAPI = async (User, sku, originalId, vendorId, name, callback) => {
  try {
    const response = await genericSupplierEndpoint(User).get(`/product/${sku}/Availability?OriginalId=${originalId}&VendorId=${vendorId}`);
    if (callback) callback(response)
    PipeSingleton.appendInGroupResponse('AVAILABILITY_GENERIC_GROUP', name, { response, sku })
    return response;
  } catch (e) {
    throw e;
  }
};
const processAvailabilityGeneric = (response) => {
  Store.dispatch({
    type: FETCH_AVAILABILITY_GENERIC_SUCCESS,
    payload: {
      response,
    },
  });
};

const PipeSingleton = new PipeProviderStateSingleton()
PipeSingleton.addReturnCallbackGroup('AVAILABILITY_GENERIC_GROUP', (responses) => {
  processAvailabilityGeneric(responses)
})

const handlePipeSingleton = () => {
  const name = generateUUID()
  PipeSingleton.appendInGroupRequest('AVAILABILITY_GENERIC_GROUP', name);
  return name;
}

export const FetchAvailabilityGeneric = async (User, finallyCallback = () => { }, { sku, originalId, vendorId, callback }) => {
  const name = handlePipeSingleton()
  try {
    await fetchFromCacheOrAPI(`FETCH_AVAILABILITY_GENERIC_${sku}`, () => fetchAvailabilityGenericAPI(User, sku, originalId, vendorId, name, callback));
  } catch (e) {
    if (callback) callback(null, e);
    PipeSingleton.appendInGroupResponse('AVAILABILITY_GENERIC_GROUP', name, {
      response: {
        data: [{
          available: false,
          error: e,
        }]
      }, sku
    })
    Store.dispatch({
      type: FETCH_AVAILABILITY_GENERIC_FAIL,
      error: e,
      payload: {
        sku,
      },
    });
  } finally {
    PipeSingleton.executeCallbackForGroup('AVAILABILITY_GENERIC_GROUP', () => {
      finallyCallback();
    })
  }
};

export const getAvailabilityGeneric = (User, sku, originalId, vendorId) => {
  return new Promise((resolve, reject) => {
    genericSupplierEndpoint(User)
      .get(`/product/${sku}/Availability?OriginalId=${originalId}&VendorId=${vendorId}`)
      .then((data) => {
        resolve(data)
      }
      )
      .catch((err) => {
        reject(err);
      });
  });
};